import 'babel-polyfill';

import Vue from 'vue';

import 'normalize.css';
import ElementUI from 'element-ui';
import SvgIcon from 'vue-svgicon';

import '@/styles/element-variables.scss';
import '@/styles/index.scss';

import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import * as filters from '@/filters/index';
import '@/icons/components';
import '@/router/permission';
import '@/router/checkExpire';

//腾讯tim停用 20251231
// import TIM from '@/plugin/tim';
import NIM from '@/plugin/nim';

import scroll from 'vue-seamless-scroll';

import VueDOMPurifyHTML from 'vue-dompurify-html';

import VueTimeago from 'vue-timeago';

import VueClipboard from 'vue-clipboard2'



Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
    ja: require('date-fns/locale/ja')
  }
});

Vue.use(VueDOMPurifyHTML);

Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as any)[key]);
});
Vue.use(ElementUI);
Vue.use(scroll);
//腾讯tim停用 20251231
// Vue.prototype.TIM = TIM;
Vue.prototype.NIM = NIM;

Vue.use(SvgIcon, {
  tagName: 'svg-icon'
});

Vue.config.productionTip = false;

//复制功能
Vue.use(VueClipboard)

new Vue({
  store,
  router,
  created: () => {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      store.replaceState(
        Object.assign(
          {},
          store.state,
          JSON.parse(sessionStorage.getItem('store') || '')
        )
      );
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(store.state));
    });
  },
  render: (h) => h(App)
}).$mount('#app');
